import React, { useState, useEffect } from 'react';

const TypewriterText = ({ text, delay = 100, className = '' }) => {
  const [currentText, setCurrentText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setCurrentText(prevText => prevText + text[currentIndex]);
        setCurrentIndex(prevIndex => prevIndex + 1);
      }, delay);

      return () => clearTimeout(timeout);
    } else {
      // Stop cursor blinking after typing is complete
      setShowCursor(false);
    }
  }, [currentIndex, delay, text]);

  return (
    <span className={className}>
      {currentText}
      {showCursor && (
        <span className="inline-block w-0.5 h-[1em] bg-cyan-400 ml-1 animate-pulse" />
      )}
    </span>
  );
};

export default TypewriterText;
